import { useMemo } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { RVRoutingPage, useHeaderActions } from "@regal-voice/ui";
import AgentNavBarButtons from "Components/shared/AgentNavBarButtons/AgentNavBarButtons";
import { useEmailReauthWarning } from "Components/shared/emailIntegrations/hooks/useEmailReauthWarning/useEmailReauthWarning";
import { AgentDesktopPaths } from "Pages/agentDesktop/paths";
import { getEmbedUiConfigByKey } from "Services/embed/CrossDomainMessenger";
import { useFlags } from "Services/FeatureFlagService";

import { AgentDesktopSideNav } from "./Pages/AgentDesktopTasks/Components/AgentDesktopSideNav/AgentDesktopSideNav";

export default function AgentDesktopRouter(): JSX.Element {
    const navigate = useNavigate();
    const { contactList } = useFlags();

    const { pathname } = useLocation();
    const sub = pathname.split("/")[2];
    const hideSubnavWhenEmbedded = getEmbedUiConfigByKey("hideNavigation");

    const showADSideNav = contactList && sub != AgentDesktopPaths.mySettings && !hideSubnavWhenEmbedded;

    useEmailReauthWarning(navigate);

    const agentNavBarButtons = useMemo(() => <AgentNavBarButtons />, []);
    useHeaderActions(sub !== AgentDesktopPaths.mySettings ? agentNavBarButtons : null);

    return <RVRoutingPage nav={showADSideNav ? <AgentDesktopSideNav /> : undefined} />;
}
